import type { OrderedMap } from 'immutable';
import type ViewCategoryStore from '../../AppData/_stores/ViewCategoryStore';
import type ViewProductStore from '../../AppData/_stores/ViewProductStore';
import type { AppLocale } from '../../Common/SEO/SeoLinks';

export const getLocalizedViewCategorySlug = (category: ViewCategoryStore, locale: AppLocale) => {
  return category.get('url_slugs').get(locale) ?? category.get('url_slug');
}

export const getProductCategoryPath = (
  viewProductData: ViewProductStore,
  viewCategories: OrderedMap<string, ViewCategoryStore>,
) => {
  const categories = viewProductData.get('categories')
    .toArray()
    .map(categoryId => viewCategories.get(String(categoryId)))
    .filter((category): category is ViewCategoryStore => category !== undefined)
    .sort((a, b) => a.get('theorder') - b.get('theorder'));

  const childCategory = categories.find(category => category.get('id_parent') !== null);

  if (childCategory !== undefined) {
    const parentCategory = viewCategories.get(String(childCategory.get('id_parent')));
    return parentCategory !== undefined ? [parentCategory, childCategory] : [childCategory];
  }

  return categories.slice(0, 1);
}
